import { render, staticRenderFns } from "./coursePackageList.vue?vue&type=template&id=5cfda0e0&scoped=true"
import script from "./coursePackageList.vue?vue&type=script&lang=js"
export * from "./coursePackageList.vue?vue&type=script&lang=js"
import style0 from "./coursePackageList.vue?vue&type=style&index=0&id=5cfda0e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfda0e0",
  null
  
)

export default component.exports